import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import IsolationGroupsResource from "@ane/exp-data/lib/resources/expapiv2/IsolationGroups.resource";
import { combineEpics } from "redux-observable";
import { replaceIsolationGroup } from "../../common/epics/actions.js";
import { prefix } from "./constants.js";
const archiveUnarchiveIsolationGroupEpicReducerArgs = {
  actionPrefix: `${prefix}/ARCHIVEUNARCHIVE`,
  reduxKeyNested: () => ["archiveUnarchiveResult"],
  loadResource: (inputPayload) => IsolationGroupsResource.updateIsolationGroup(inputPayload.workspaceId, inputPayload.id, inputPayload.data),
  onCompleteSuccess: (resourceResult) => resourceResult,
  afterActionsOnSuccess: (inputPayload, outputPayload) => [
    replaceIsolationGroup(outputPayload)
  ]
};
const archiveUnarchiveIsolationGroupEpicReducer = loadResourcesUtils(archiveUnarchiveIsolationGroupEpicReducerArgs);
const rootEpic = combineEpics(archiveUnarchiveIsolationGroupEpicReducer.epic);
export {
  archiveUnarchiveIsolationGroupEpicReducer,
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
